import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = { class: "container mb-5 px-12" }
const _hoisted_4 = { class: "my-title capitalize" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Scheda Cliente ")
const _hoisted_6 = { class: "my-buttons my-card--body mb-5" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Aggiorna Dati ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "my-subtitle mt-5" }, "Aggiungi nuova seduta programmata", -1)
const _hoisted_9 = { class: "col-md-12 text-center mb-3" }
const _hoisted_10 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_11 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_12 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_13 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_14 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_15 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_16 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_17 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_18 = { class: "col-md-12 text-center mb-3" }
const _hoisted_19 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_20 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_21 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_22 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_23 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_24 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_25 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_26 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_27 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_28 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_29 = { class: "col-md-12 text-center mb-3" }
const _hoisted_30 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_31 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_32 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_33 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_34 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_35 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_36 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_37 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_38 = { class: "pb-3 flex flex-col md:flex-row justify-center items-center" }
const _hoisted_39 = { class: "rounded-lg flex-grow-0 w-full lg:w-10/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_TableInfoCliente = _resolveComponent("TableInfoCliente")!
  const _component_TableListaSedute = _resolveComponent("TableListaSedute")!
  const _component_TableListaAnalisi = _resolveComponent("TableListaAnalisi")!
  const _component_AggiungiSedutaProgrammata = _resolveComponent("AggiungiSedutaProgrammata")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("i", null, _toDisplayString(_ctx.schedaCliente?.nome) + " " + _toDisplayString(_ctx.schedaCliente?.cognome), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-sync",
            onClick: _ctx.refreshPage
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_TableInfoCliente, {
          schedaCliente: _ctx.schedaCliente!
        }, null, 8, ["schedaCliente"]),
        _createVNode(_component_TableListaSedute, {
          listaSeduteEffettuate: _ctx.listaSeduteEffettuate,
          tipoMacchina: _ctx.tipoMacchina
        }, null, 8, ["listaSeduteEffettuate", "tipoMacchina"]),
        (
            _ctx.tipoMacchina === 'TB' ||
            _ctx.tipoMacchina === 'TF' ||
            (_ctx.tipoMacchina === 'LT' && _ctx.dbData?.heartbeat?.f_analisi == 1)
          )
          ? (_openBlock(), _createBlock(_component_TableListaAnalisi, {
              key: 0,
              listaAnalisiEffettuate: _ctx.listaAnalisiEffettuate,
              tipoMacchina: _ctx.tipoMacchina,
              openModalDettagliAnalisi: _ctx.openModalDettagliAnalisi
            }, null, 8, ["listaAnalisiEffettuate", "tipoMacchina", "openModalDettagliAnalisi"]))
          : _createCommentVNode("", true),
        _hoisted_8,
        (
            _ctx.tipoMacchina === 'TB' ||
            _ctx.tipoMacchina === 'CT' ||
            _ctx.tipoMacchina === 'TF' ||
            _ctx.tipoMacchina === 'FB' ||
            _ctx.tipoMacchina === 'XT' ||
            _ctx.tipoMacchina === 'LT' ||
            _ctx.tipoMacchina === 'BP' ||
            _ctx.tipoMacchina === 'XP'
          )
          ? (_openBlock(), _createBlock(_component_AggiungiSedutaProgrammata, {
              key: 1,
              tipoMacchina: _ctx.tipoMacchina,
              salvaSedutaProgrammata: _ctx.salvaSedutaProgrammata
            }, null, 8, ["tipoMacchina", "salvaSedutaProgrammata"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.tipoMacchina === 'TB')
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          classes: "p-10 w-full lg:w-2/3",
          isShowing: _ctx.statoModaleDettagliAnalisi.isOpen,
          onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.statoModaleDettagliAnalisi.isOpen = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fillFormTB && _ctx.fillFormTB(...args))),
                class: "btn btn-primary"
              }, " Download PDF ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Table, {
                  data: [
              { label: 'Nome', value: _ctx.statoModaleDettagliAnalisi.seduta.nome },
              {
                label: 'Cognome',
                value: _ctx.statoModaleDettagliAnalisi.seduta.cognome,
              },
              { label: 'Data di Nascita', value: _ctx.schedaCliente?.datanascita },
              { label: 'Telefono', value: _ctx.schedaCliente?.tel },
              {
                label: 'Morfologia',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Morfologia,
              },
              { label: 'BMI', value: _ctx.statoModaleDettagliAnalisi.seduta.BMI },
              { label: 'Peso', value: _ctx.statoModaleDettagliAnalisi.seduta.Peso },
              {
                label: 'PesoForma',
                value: _ctx.statoModaleDettagliAnalisi.seduta.PesoForma,
              },
              {
                label: 'MetBasale',
                value: _ctx.statoModaleDettagliAnalisi.seduta.MetBasale,
              },
            ],
                  config: {
              columns: [
                { header: 'Generali', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'AcquaTot',
                value: _ctx.statoModaleDettagliAnalisi.seduta.AcquaTot,
              },
              {
                label: 'AcquaIntra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.AcquaIntra,
              },
              {
                label: 'AcquaExtra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.AcquaExtra,
              },
              {
                label: 'Ritenzione',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Ritenzione,
              },
            ],
                  config: {
              columns: [
                { header: 'Analisi delle Acque', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Massa Grassa',
                value: _ctx.statoModaleDettagliAnalisi.seduta.MassaGrassa,
              },
              {
                label: 'Massa Magra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.MassaMagra,
              },
              {
                label: 'Massa Muscolare',
                value: _ctx.statoModaleDettagliAnalisi.seduta.MassaMucolare,
              },
              {
                label: 'Tono Muscolare',
                value: _ctx.statoModaleDettagliAnalisi.seduta.TonoMuscolare,
              },
              {
                label: 'Cellulite',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Cellulite,
              },
            ],
                  config: {
              columns: [
                { header: 'Analisi delle Masse', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: '1',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P1 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A1 ??
                  '',
              },
              {
                label: '2',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P2 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A2 ??
                  '',
              },
              {
                label: '3',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P3 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A3 ??
                  '',
              },
              {
                label: '4',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P4 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A4 ??
                  '',
              },
              {
                label: '5',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P5 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A5 ??
                  '',
              },
            ],
                  config: {
              columns: [
                { header: 'Problematiche ', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isShowing"]))
      : _createCommentVNode("", true),
    (_ctx.tipoMacchina === 'TF')
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          classes: "p-10 w-full lg:w-2/3",
          isShowing: _ctx.statoModaleDettagliAnalisi.isOpen,
          onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.statoModaleDettagliAnalisi.isOpen = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fillFormTF && _ctx.fillFormTF(...args))),
                class: "btn btn-primary"
              }, " Download PDF ")
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Nome',
                value: _ctx.statoModaleDettagliAnalisi.seduta.nome,
              },
              {
                label: 'Cognome',
                value: _ctx.statoModaleDettagliAnalisi.seduta.cognome,
              },
              {
                label: 'Data di Nascita',
                value: _ctx.schedaCliente?.datanascita,
              },
              {
                label: 'Telefono',
                value: _ctx.schedaCliente?.tel,
              },
              {
                label: 'Fototipo',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Fototipo,
              },
              {
                label: 'Trattamenti Consigliati',
                value: _ctx.statoModaleDettagliAnalisi.seduta.N_Trattamenti,
              },
            ],
                  config: {
              columns: [
                { header: 'Generali', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Acqua Totale',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Acqua,
              },
              {
                label: 'Acqua Intra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Acqua_intra,
              },
              {
                label: 'Acqua Extra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Acqua_extra,
              },
              {
                label: 'Ritenzione',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Rit_Idrica,
              },
              {
                label: 'Disidratazione',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Disidratazione_sup,
              },
            ],
                  config: {
              columns: [
                { header: 'Acqua e sua distribuzione', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Strato Corneo',
                value: _ctx.statoModaleDettagliAnalisi.seduta.StatoCorneo,
              },
              {
                label: 'Ph Stimato',
                value: _ctx.statoModaleDettagliAnalisi.seduta.PH,
              },
              { label: 'Sebo', value: _ctx.statoModaleDettagliAnalisi.seduta.Sebo },
            ],
                  config: {
              columns: [
                { header: 'Epidermide', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Elasticità',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Elasticita,
              },
              {
                label: 'Tonicità',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Tonicita,
              },
              {
                label: 'Sensibilità',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Sensibilita,
              },
            ],
                  config: {
              columns: [
                { header: 'Derma', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: '1',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P1 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A1 ??
                  '',
              },
              {
                label: '2',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P2 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A2 ??
                  '',
              },
              {
                label: '3',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P3 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A3 ??
                  '',
              },
              {
                label: '4',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P4 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A4 ??
                  '',
              },
              {
                label: '5',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P5 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A5 ??
                  '',
              },
            ],
                  config: {
              columns: [
                { header: 'Problematiche ', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isShowing"]))
      : _createCommentVNode("", true),
    (_ctx.tipoMacchina === 'LT' && _ctx.dbData?.heartbeat?.f_analisi == 1)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          classes: "p-10 w-full lg:w-2/3",
          isShowing: _ctx.statoModaleDettagliAnalisi.isOpen,
          onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.statoModaleDettagliAnalisi.isOpen = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fillFormTF && _ctx.fillFormTF(...args))),
                class: "btn btn-primary"
              }, " Download PDF ")
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Nome',
                value: _ctx.statoModaleDettagliAnalisi.seduta.nome,
              },
              {
                label: 'Cognome',
                value: _ctx.statoModaleDettagliAnalisi.seduta.cognome,
              },
              {
                label: 'Data di Nascita',
                value: _ctx.schedaCliente?.datanascita,
              },
              {
                label: 'Telefono',
                value: _ctx.schedaCliente?.tel,
              },
              {
                label: 'Fototipo',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Fototipo,
              },
              {
                label: 'Trattamenti Consigliati',
                value: _ctx.statoModaleDettagliAnalisi.seduta.N_Trattamenti,
              },
            ],
                  config: {
              columns: [
                { header: 'Generali', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Acqua Totale',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Acqua,
              },
              {
                label: 'Acqua Intra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Acqua_intra,
              },
              {
                label: 'Acqua Extra',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Acqua_extra,
              },
              {
                label: 'Ritenzione',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Rit_Idrica,
              },
              {
                label: 'Disidratazione',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Disidratazione_sup,
              },
            ],
                  config: {
              columns: [
                { header: 'Acqua e sua distribuzione', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Strato Corneo',
                value: _ctx.statoModaleDettagliAnalisi.seduta.StatoCorneo,
              },
              {
                label: 'Ph Stimato',
                value: _ctx.statoModaleDettagliAnalisi.seduta.PH,
              },
              { label: 'Sebo', value: _ctx.statoModaleDettagliAnalisi.seduta.Sebo },
            ],
                  config: {
              columns: [
                { header: 'Epidermide', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: 'Elasticità',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Elasticita,
              },
              {
                label: 'Tonicità',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Tonicita,
              },
              {
                label: 'Sensibilità',
                value: _ctx.statoModaleDettagliAnalisi.seduta.Sensibilita,
              },
            ],
                  config: {
              columns: [
                { header: 'Derma', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_Table, {
                  data: [
              {
                label: '1',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P1 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A1 ??
                  '',
              },
              {
                label: '2',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P2 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A2 ??
                  '',
              },
              {
                label: '3',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P3 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A3 ??
                  '',
              },
              {
                label: '4',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P4 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A4 ??
                  '',
              },
              {
                label: '5',
                value:
                  _ctx.statoModaleDettagliAnalisi.seduta.P5 ??
                  '' + _ctx.statoModaleDettagliAnalisi.seduta.A5 ??
                  '',
              },
            ],
                  config: {
              columns: [
                { header: 'Problematiche ', path: 'label' },
                { header: '', path: 'value', classes: 'capitalize' },
              ],
            }
                }, null, 8, ["data"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isShowing"]))
      : _createCommentVNode("", true)
  ]))
}